/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DetailedOptimizerRequest } from '../models/DetailedOptimizerRequest';
import type { DetailedOptimizerResponse } from '../models/DetailedOptimizerResponse';
import type { DetailedOptimizerWriteRequest } from '../models/DetailedOptimizerWriteRequest';
import type { DetailedOptimizerWriteResponse } from '../models/DetailedOptimizerWriteResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DetailedOptimizerService {
    /**
     * 詳細生産計画立案
     * シフト割当・スタッフ能力・生産タスクを入力として、人員能力制約に基づく詳細スケジュールを生成します。
     * @param requestBody
     * @returns DetailedOptimizerResponse Successful Response
     * @throws ApiError
     */
    public static runDetailedOptimizer(
        requestBody: DetailedOptimizerRequest,
    ): CancelablePromise<DetailedOptimizerResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/detailed-optimizer',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * 最適化結果をExcelに書き戻し
     * 詳細最適化の結果（セル書き込み指示）をOneDrive上のExcelファイルに書き戻します。
     * @param requestBody
     * @returns DetailedOptimizerWriteResponse Successful Response
     * @throws ApiError
     */
    public static writeDetailedOptimizer(
        requestBody: DetailedOptimizerWriteRequest,
    ): CancelablePromise<DetailedOptimizerWriteResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/detailed-optimizer-write',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
